export default {"src":"/_next/static/media/doctors.16e1721d.svg","height":120,"width":121};